






























































import { Component } from 'vue-property-decorator';

import CoinCustomizationForm from '@/componentsV2/templates/CoinCustomizationFormV2/CoinCustomizationFormV2.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { BusinessOnboardingYourDigitalCoinsForm } from '@/models/business-onboarding';

import InternationalizationService from '@/api/InternationalizationService';

import uuidv4 from '@/utils/uuidv4';
import { scrollToTop } from '@/utils/scrollToTop';

import { BUSINESS_ONBOARDING_UUID_CREATION } from '@/store/modules/businessOnboarding';

import YourDigitalCoinBase from './YourDigitalCoinBase.vue';
import YourDigitalCoinIlustra from './YourDigitalCoinIlustra.vue';
import eventBus from '@/utils/eventBus';
import { FilledButton } from '@/components/molecules';
import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';

@Component({
  components: {
    CoinCustomizationForm,
    Typography,
    YourDigitalCoinIlustra,
    FilledButton
  }
})
export default class YourDigitalCoin extends YourDigitalCoinBase {
  internationalizationService = new InternationalizationService();

  defaultFormData: BusinessOnboardingYourDigitalCoinsForm = this.$store.getters[
    'businessOnboarding/getYourDigitalCoinForm'
  ];

  get currentCountry() {
    return this.$store.getters['internationalization/getCurrentCountry'];
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  get headerCopies() {
    return {
      title: 'Customize Branded Coin',
      description:
        'Forge your branded digital currency, setting your business apart and empowering members with seamless rewards and transactions.'
    };
  }

  async getPreSelectedCountry() {
    const token = this.signUpService.getCredentials(this.isImpersonated);

    if (!token || this.currentCountry) return;

    const { data } = await this.internationalizationService.getCurrentCountry();

    if (!data) return;

    this.$store.dispatch('internationalization/SET_CURRENT_COUNTRY', data);
  }

  handleNext() {
    eventBus.$emit('submitCoinUpdates');
  }

  handleBack() {
    this.$router.push(OnlineOnboardingURL.REWARD_RATIO);
  }

  mounted() {
    this.getPreSelectedCountry();

    scrollToTop('bo-base-layout__right');

    this.$showMediumBackgroundLocker();
  }

  created() {
    if (!localStorage.getItem(BUSINESS_ONBOARDING_UUID_CREATION)) {
      localStorage.setItem(BUSINESS_ONBOARDING_UUID_CREATION, uuidv4());
    }

    if (!this.businessInfo) {
      this.businessService.getBusinessInfo().then((res: any) => {
        eventBus.$emit('setBusinessInfo', res.data);
        const data = res.data;
        data.manager = data.loggedInManager;
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.$store.getters['business/getBusinessState'],
          ...data
        });
      });
    }
  }

  beforeDestroy() {
    this.$hideMediumBackgroundLocker();
  }
}
